import "./App.css";
import { CssVarsProvider } from "@mui/joy/styles";
import CssBaseline from "@mui/joy/CssBaseline";
import "quill/dist/quill.snow.css"; //TODO Works if seperate component, not here or where want to use on page
import Box from "@mui/joy/Box";
import Breadcrumbs from "@mui/joy/Breadcrumbs";
import Link from "@mui/joy/Link";

import Header from "./components/Header";
import { Amplify, ResourcesConfig } from "aws-amplify";

import { withAuthenticator } from "@aws-amplify/ui-react";
import "@aws-amplify/ui-react/styles.css";
import { Route, Routes, Link as RouterLink } from "react-router-dom";
import { PrimeReactProvider } from "primereact/api";

import "react-international-phone/style.css";
import "primereact/resources/themes/lara-light-cyan/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";
import "quill/dist/quill.snow.css";

import { Dispatch, useEffect, useState } from "react";
import { UserSession } from "./models/UserSession";
import { fetchUserAttributes, FetchUserAttributesOutput } from "aws-amplify/auth";
import { UserTypes } from "./enum/UserTypes";
import GlobalLoader from "./components/GlobalLoader";
import SideMenuComponent from "./components/SideMenu";
import BreadCrumbsComponent from "./components/Breadcrumbs";
import { routesArray } from "./constantsAndDefaults/routes";
import { portalInit } from "./service/api-service";
import * as Sentry from "@sentry/react";
import { ToastProvider } from "./context/ToastContext";
import { SiteProvider, useSiteContext } from "./context/siteContext";
import { Error } from "./assets/icons";
import { SessionProvider, useSession } from "./context/SessionContext";
import { Card } from "primereact/card";
import { Button } from "primereact/button";

let config: ResourcesConfig;

if (process.env.REACT_APP_ENV === `production`) {
  config = {
    API: {
      REST: {
        core: {
          endpoint: "https://0se6meo1i0.execute-api.eu-west-1.amazonaws.com/prod/",
          region: "eu-west-1",
        },
        dsf: {
          endpoint: "https://i6pwlqvtyz3ck6kq36kdcyoz5m0xyykg.lambda-url.eu-west-1.on.aws/",
          region: "eu-west-1",
        },
        open: {
          endpoint: "https://zwc8dbpnvf.execute-api.eu-west-1.amazonaws.com/prod/",
          region: "eu-west-1",
        },
      },
    },
    Auth: {
      Cognito: {
        identityPoolId: "eu-west-1:30fb5f99-a5bd-4dc3-83a4-a31ea025ada3",
        userPoolClientId: "pc1d2v1fmm7v838rdcau2q5tp",
        userPoolId: "eu-west-1_SAqkV5EJF",
        loginWith: {
          // Optional
          oauth: {
            domain: "https://dsf-portal.auth.eu-west-1.amazoncognito.com",
            scopes: ["openid email phone profile aws.cognito.signin.user.admin "],
            redirectSignIn: ["http://localhost:3000/", "https://example.com/"],
            redirectSignOut: ["http://localhost:3000/", "https://example.com/"],
            responseType: "code",
          },
        },
      },
    },
    Storage: {
      S3: {
        bucket: "main-backendstack-backendstackcorebkte963be47-nkrxmrmnulbz",
        region: "eu-west-1",
      },
    },
  };
} else if (process.env.REACT_APP_ENV === `localhost`) {
  config = {
    API: {
      REST: {
        core: {
          endpoint: "http://localhost:3001/",
          region: "eu-west-1",
        },
        dsf: {
          endpoint: "http://localhost:3001/",
          region: "eu-west-1",
        },
        open: {
          endpoint: "http://localhost:3001/",
          region: "eu-west-1",
        },
      },
    },
    Auth: {
      Cognito: {
        identityPoolId: "eu-west-1:30fb5f99-a5bd-4dc3-83a4-a31ea025ada3",
        userPoolClientId: "pc1d2v1fmm7v838rdcau2q5tp",
        userPoolId: "eu-west-1_SAqkV5EJF",
        loginWith: {
          // Optional
          oauth: {
            domain: "https://dsf-portal.auth.eu-west-1.amazoncognito.com",
            scopes: ["openid email phone profile aws.cognito.signin.user.admin "],
            redirectSignIn: ["http://localhost:3000/", "https://example.com/"],
            redirectSignOut: ["http://localhost:3000/", "https://example.com/"],
            responseType: "code",
          },
        },
      },
    },
    Storage: {
      S3: {
        bucket: "develop-backendstack-backendstackcorebkte963be47-ml6wopsjijbo",
        region: "eu-west-1",
      },
    },
  };
} else {
  config = {
    API: {
      REST: {
        core: {
          endpoint: "https://vaegw7bbfc.execute-api.eu-west-1.amazonaws.com/prod/",
          region: "eu-west-1",
        },
        dsf: {
          endpoint: "https://fooyc4cumbayyc5mnl7d4rnqaa0btbsh.lambda-url.eu-west-1.on.aws/",
          region: "eu-west-1",
        },
        open: {
          endpoint: "https://vt5j4bcrpg.execute-api.eu-west-1.amazonaws.com/prod/",
          region: "eu-west-1",
        },
      },
    },
    Auth: {
      Cognito: {
        identityPoolId: "eu-west-1:30fb5f99-a5bd-4dc3-83a4-a31ea025ada3",
        userPoolClientId: "pc1d2v1fmm7v838rdcau2q5tp",
        userPoolId: "eu-west-1_SAqkV5EJF",
        loginWith: {
          // Optional
          oauth: {
            domain: "https://dsf-portal.auth.eu-west-1.amazoncognito.com",
            scopes: ["openid email phone profile aws.cognito.signin.user.admin "],
            redirectSignIn: ["http://localhost:3000/", "https://example.com/"],
            redirectSignOut: ["http://localhost:3000/", "https://example.com/"],
            responseType: "code",
          },
        },
      },
    },
    Storage: {
      S3: {
        bucket: "develop-backendstack-backendstackcorebkte963be47-ml6wopsjijbo",
        region: "eu-west-1",
      },
    },
  };
}

Amplify.configure(config);

let currentUser: Promise<FetchUserAttributesOutput>;

const getHeader = () => {
  return (
    <div
      style={{
        backgroundColor: "white",
        textAlign: "center",
        margin: "0px 1px -5px 1px",
        position: "relative",
      }}
    >
      <img
        src={require("./assets/icon/DSF_Logo-Low-trimmed2.png")}
        style={{ width: "90%", margin: "auto", paddingTop: 15 }}
      />
    </div>
  );
};

function App() {
  const { session: activeSession, setSession: setActiveSession, isLoading: sessionLoading } = useSession();
  const { site, getSite, setSite } = useSiteContext();

  const [employee, setEmployee] = useState({} as any);
  const [subContractor, setSubContractor] = useState({} as any);
  const [accessLevel, setAccessLevel] = useState({} as any);
  const [breadcrumbs, setBreadcrumbs] = useState([] as any[]);
  const [loading, setLoading] = useState(false);
  const [equipment, setEquipment] = useState({} as any);
  const [chemical, setChemical] = useState({} as any);
  const [vehicle, setVehicle] = useState({} as any);
  const [form, setForm] = useState({} as any);
  Sentry.captureException("Test Capture Exception - admin portal");

  // useEffect(() => {
  //   getSession(activeSession, setActiveSession);
  // }, [activeSession]);

  useEffect(() => {
    if (activeSession?.site_id) {
      getSite(activeSession?.site_id);
    } else {
      setSite(null);
    }
  }, [activeSession?.site_id]);

  useEffect(() => {
    if (activeSession?.client_id) {
      portalInit()
        .then(data => {
          if (data) {
            const newSession = {
              ...activeSession,
              client_name: data.name,
              client_logo_s3_key: data?.s3_key || data.id,
              client_logo: data.photo,
              employee_id: data.employee,
            };
            setActiveSession(newSession);
          }
        })
        .catch(error => {
          console.error("Error initializing portal:", error);
        });
    }
  }, [activeSession?.client_id]);

  const getRoutes = () => {
    // Don't render routes if session isn't initialized yet
    if (!activeSession?.user_type && (loading || sessionLoading)) {
      return (
        <Routes>
          <Route path="*" element={<div>Loading...</div>} />
        </Routes>
      );
    }

    const filteredRoutes = routesArray.filter(e => (e.path == '/' && e.access.includes(activeSession?.user_type) || e.path != '/'));

    return (
      <Routes>
        {filteredRoutes.map((e, i) => {
          return (
            <Route
              path={e.path}
              key={`route-${i}`}
              element={
                <e.element
                  equipment={equipment}
                  setEquipment={setEquipment}
                  form={equipment}
                  setForm={setEquipment}
                  accessLevel={accessLevel}
                  setAccessLevel={setAccessLevel}
                  employee={employee}
                  setEmployee={setEmployee}
                  session={activeSession}
                  setSession={setActiveSession}
                  globalLoader={loading}
                  setGlobalLoader={setLoading}
                  breadcrumbs={breadcrumbs}
                  vehicle={vehicle}
                  setVehicle={setVehicle}
                  chemical={chemical}
                  setChemical={setChemical}
                  setBreadcrumbs={setBreadcrumbs}
                  setSubContractor={setSubContractor}
                  subContractor={subContractor}
                />
              }
            />
          );
        })}
        <Route
          path="*"
          element={
            <div style={{ padding: "20px" }}>
              <h2>Route Not Found</h2>
              <p>Current path: {window.location.pathname}</p>
              <p>User type: {activeSession?.user_type}</p>
              <p>Available routes: {filteredRoutes.length}</p>
            </div>
          }
        />
      </Routes>
    );
  };

  return (
    <CssVarsProvider disableTransitionOnChange>
      <PrimeReactProvider>
        {(loading || sessionLoading) ? <GlobalLoader message={sessionLoading ? "Loading user details..." : "Loading..."} /> : ""}
        <CssBaseline />
        {
          (!activeSession.user_type || activeSession.user_type === UserTypes.Unknown) && !(loading || sessionLoading) ? (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                minHeight: "100vh",
                width: "100vw",
                backgroundColor: "#f5f5f5",
                padding: 2,
              }}
            >
              <Card
                style={{
                  maxWidth: '500px',
                  width: "100%",
                  padding: '2rem',
                  textAlign: "center",
                  boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
                  borderRadius: '8px',
                  backgroundColor: "white",
                  border: 'none'
                }}
              >
                <div style={{ marginBottom: '1.5rem' }}>
                  <Error fill="#ff6b35" height={64} width={64} />
                </div>
                <div style={{ marginBottom: '1rem' }}>
                  <h2 style={{
                    margin: 0,
                    color: "#333",
                    fontSize: "1.5rem",
                    fontWeight: 600,
                    marginBottom: "0.5rem"
                  }}>
                    Access Restricted
                  </h2>
                </div>
                <div style={{ marginBottom: '1.5rem' }}>
                  <p style={{
                    margin: 0,
                    color: "#666",
                    fontSize: "1rem",
                    lineHeight: 1.5
                  }}>
                    Your account might not have access to this portal. Please try refreshing the page, and if the issue persists, contact our support team for assistance.
                  </p>
                </div>
                <Button label="Refresh your browser" icon="pi pi-refresh" onClick={() => {
                  window.location.reload();
                }} />
              </Card>
            </Box>
          ) :
            (
              <Box sx={{ display: "flex", minHeight: "100dvh" }}>
                <div
                  // Add so that the sidebar can be fixed when scrolling past the page height
                  style={{
                    position: "fixed",
                    top: 0,
                    left: 0,
                    height: "100vh",
                    width: "var(--Sidebar-width)",
                    zIndex: 1000,
                  }}
                >
                  <Header />
                  <SideMenuComponent
                    session={activeSession}
                    setSession={setActiveSession}
                    globalLoader={loading}
                    setGlobalLoader={setLoading}
                    breadcrumbs={breadcrumbs}
                    setBreadcrumbs={setBreadcrumbs}
                  />
                </div>

                <Box
                  component="main"
                  className="MainContent"
                  sx={{
                    marginLeft: { xs: 0, md: "var(--Sidebar-width)" },
                    px: { xs: 2, md: 4 },
                    pt: {
                      xs: "calc(12px + var(--Header-height))",
                      sm: "calc(12px + var(--Header-height))",
                      md: 3,
                    },
                    pb: { xs: 2, sm: 2, md: 3 },
                    flex: 1,
                    display: "flex",
                    flexDirection: "column",
                    minWidth: 0,
                    height: "100dvh",
                    gap: 1,
                  }}
                >
                  {site && !site?.setup_complete && (
                    <div
                      style={{
                        minHeight: "40px",
                        width: "calc(100vw - var(--Sidebar-width))",
                        border: "1px solid red",
                        color: "#C41C1CFF",
                        marginTop: "-1.5rem",
                        marginLeft: "-2rem",
                        padding: "0.5rem",
                        backgroundColor: "rgba(196, 28, 28, 0.2)",
                      }}
                    >
                      <div style={{ display: "flex", alignItems: "start", gap: "2rem" }}>
                        <div>
                          <Error fill={"#C41C1CFF"} height={26} width={26} />
                        </div>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                          <span style={{ fontSize: "1rem", fontWeight: 600 }}>
                            Action Required: Your site setup is incomplete. Please complete the{" "}
                            <RouterLink
                              to={"/people-and-attendance/appointments"}
                              style={{ textDecoration: "underline", color: "inherit" }}
                            >
                              Appointments
                            </RouterLink>{" "}
                            to enable full functionality.
                          </span>
                        </div>
                      </div>
                    </div>
                  )}

                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    <BreadCrumbsComponent
                      session={activeSession}
                      setSession={setActiveSession}
                      globalLoader={loading}
                      setGlobalLoader={setLoading}
                      breadcrumbs={breadcrumbs}
                      setBreadcrumbs={setBreadcrumbs}
                    />
                  </Box>
                  {getRoutes()}
                </Box>
              </Box>
            )
        }
      </PrimeReactProvider>
    </CssVarsProvider >
  );
}

const AppWithAuth = withAuthenticator(App, {
  hideSignUp: true,
  components: {
    Header: getHeader,
  },
});

export default function AppRoot() {
  return (
    <SessionProvider>
      <SiteProvider>
        <ToastProvider>
          <AppWithAuth />
        </ToastProvider>
      </SiteProvider>
    </SessionProvider>
  );
}
